export const VLM_SERVICE_TIERS = [
  {
    id: 'cloud',
    label: 'O-HIVE VLM CLOUD',
  },
  {
    id: 'pro',
    label: 'O-HIVE VLM PRO',
  },
];

export const normalizeVlmServiceTier = serviceTier =>
  serviceTier === 'pro' ? 'pro' : 'cloud';

export const vlmServiceTierLabel = serviceTier =>
  VLM_SERVICE_TIERS.find(
    item => item.id === normalizeVlmServiceTier(serviceTier),
  )?.label || 'O-HIVE VLM CLOUD';
